const actionTypeIdentifier = '3D74F5FC-BE8A-4599-A14F-56B8A8AD3CB6';

export const getInventoryCircuit = `GET-ALL-EXTERNAL-INVENTORY-${actionTypeIdentifier}`;
export const getInventoryCircuitEquipment = `GET-ALL-EXTERNAL-INVENTORY-EQUIPMENT-${actionTypeIdentifier}`
export const getInventoryCircuitEquipmentModel = `GET-ALL-EXTERNAL-INVENTORY-EQUIPMENT-MODEL-${actionTypeIdentifier}`;;
export const getEquipmentDetailsList = `GET-ALL-EXTERNAL-INVENTORY-EQUIPMENT-DETAILS-${actionTypeIdentifier}`;
export const setInventoryCircuitError = `SET-ALL-EXTERNAL-INVENTORY-ERROR-${actionTypeIdentifier}`;
export const setInventoryCircuitColSearchStr = `SET-ALL-EXTERNAL-INVENTORY-COL-SEARCH-STRING-${actionTypeIdentifier}`;
export const sortInventoryCircuitItems = `SORT-ALL-EXTERNAL-INVENTORY-${actionTypeIdentifier}`;
export const setInventoryCircuitPageSize = `SET-INVENTORY-CIRCUIT-PAGESIZE-${actionTypeIdentifier}`;
export const setInventoryCircuitFilter = `SET-INVENTORY-CIRCUIT-FILTER-${actionTypeIdentifier}`;
export const applyInventoryCircuitFilter = `APPLY-INVENTORY-CIRCUIT-FILTER-${actionTypeIdentifier}`;
export const getInventoryCircuitDetail = `GET-ALL-EXTERNAL-INVENTORY-CIRCUIT-DETAIL${actionTypeIdentifier}`;
export const getInventoryUserDetail = `GET-ALL-EXTERNAL-INVENTORY-USER-DETAIL${actionTypeIdentifier}`;
export const getInventoryUserCircuitAllocation = `GET-ALL-EXTERNAL-INVENTORY-USER-CIRCUIT-ALLOCATION${actionTypeIdentifier}`;
export const getInventoryAccountCostAllocationModal = `GET-ALL-EXTERNAL-INVENTORY-ACCOUNT-COST-ALLOCATION${actionTypeIdentifier}`;
export const getUserLinkedCircuit = `GET-ALL-EXTERNAL-USER-LINKED-CIRCUIT${actionTypeIdentifier}`;
export const getAccountLinkedCircuit = `GET-ALL-EXTERNAL-ACCOUNT-LINKED-CIRCUIT${actionTypeIdentifier}`;
export const getInventoryAccountDetail = `GET-ALL-EXTERNAL-INVENTORY-ACCOUNT-DETAIL-CIRCUIT${actionTypeIdentifier}`;
export const getInventoryCircuitLocationAddress = `GET-ALL-EXTERNAL-INVENTORY-CIRCUIT-LOCATION-ONE${actionTypeIdentifier}`;
export const getInventoryCircuitLocationP2P = `GET-ALL-EXTERNAL-INVENTORY-CIRCUIT-LOCATION-TWO${actionTypeIdentifier}`;
export const getInventoryAllAccountDetails = `GET-ALL-EXTERNAL-INVENTORY-ALL-ACCOUNT-DETAILS${actionTypeIdentifier}`;
export const getInventoryAllCircuitStatuses = `GET-ALL-EXTERNAL-INVENTORY-CIRCUIT-STATUSES${actionTypeIdentifier}`;
export const getInventoryAllCircuitSimTypes = `GET-ALL-EXTERNAL-INVENTORY-CIRCUIT-SIMTYPES${actionTypeIdentifier}`;
export const getInventoryCircuitComments = `GET-ALL-EXTERNAL-INVENTORY-CIRCUIT-COMMENTS${actionTypeIdentifier}`;
export const getInventoryAllCircuitRankings = `GET-ALL-EXTERNAL-INVENTORY-CIRCUIT-RANKINGS${actionTypeIdentifier}`
export const getInventoryAllAccountTypes = `GET-ALL-EXTERNAL-INVENTORY-ACCOUNT-TYPES${actionTypeIdentifier}`;
export const getInventoryAllCircuitTypes = `GET-INVENTORY-ALL-CIRCUIT-TYPES-${actionTypeIdentifier}`;
export const getInventoryCircuitTypesByCategory = `GET-INVENTORY-CIRCUIT-TYPES-BY-CATEGORY-${actionTypeIdentifier}`;
export const getInventoryAllSubCircuitTypes = `GET-INVENTORY-ALL-SUB-CIRCUIT-TYPES-${actionTypeIdentifier}`;
export const getInventoryAllEmployees = `GET-INVENTORY-ALL-EMPLOYEES-${actionTypeIdentifier}`;
export const getInventoryAllLocations = `GET-INVENTORY-ALL-LOCATIONS-${actionTypeIdentifier}`;
export const getCircuitPIPInformationDetails = `GET-ALL-INVENTORY-CIRCUIT-PIP-INFORMATION-DETAILS-${actionTypeIdentifier}`;
export const getInventoryCircuitPortSpeed = `GET-INVENTORY-CIRCUIT-PIP-PORT-SPEED-${actionTypeIdentifier}`;
export const getInventoryCircuitCarrierQoSProfile = `GET-INVENTORY-CIRCUIT-CARRIER-QOS-PROFILE-${actionTypeIdentifier}`;
export const getInventoryCircuitVPNName = `GET-INVENTORY-CIRCUIT-VPN-NAME-${actionTypeIdentifier}`;
export const getInventoryCircuitVoiceCarSpeed = `GET-INVENTORY-CIRCUIT-VOICE-CAR-SPEED-${actionTypeIdentifier}`;
export const getInventoryCircuitSiteOfOrigin = `GET-INVENTORY-CIRCUIT-SITE-OF-ORIGIN-${actionTypeIdentifier}`;
export const resetInventoryCircuitForm = `RESET-INVENTORY-CIRCUIT-FORM-${actionTypeIdentifier}`;
export const resetInventoryCircuitData = `RESET-INVENTORY-CIRCUIT-DATA-${actionTypeIdentifier}`;
export const setInventoryCircuitFormSubmitted = `SET-INVENTORY-CIRCUIT-FORM-SUBMITTED-${actionTypeIdentifier}`;
export const setUserLinkedCircuitSearchValue = `SET-USER-LINKED-CIRCUIT-SEARCH-VALUE-${actionTypeIdentifier}`;
export const setAccountLinkedCircuitSearchValue = `SET-ACCOUNT-LINKED-CIRCUIT-SEARCH-VALUE-${actionTypeIdentifier}`;
export const updateChangeLocationSite = `UPDATE-CHANGE-LOCATION-SITE-1${actionTypeIdentifier}`;
export const updateChangeLocationSiteP2P = `UPDATE-CHANGE-LOCATION-SITE-P2P${actionTypeIdentifier}`;
export const getInventoryCircuitPlanDetails = `GET-INVENTORY-CIRCUIT-PLAN-DETAILS-${actionTypeIdentifier}`;
export const getInventoryPlanTypesByVendorByCircuitType = `GET-INVENTORY-PLAN-TYPES-BY-VENDOR-BY-CIRCUIT-TYPE-${actionTypeIdentifier}`;
export const deleteCircuitPlanComponentDetailsItem = `DELETE-CIRCUIT-PLAN-COMPONENT-DETAILS-ITEM-${actionTypeIdentifier}`;
export const updateChangeCircuitPlanComponentDetails = `UPDATE-INVENTORY-PLAN-COMPONENT-DETAILS-${actionTypeIdentifier}`;
export const getInventoryCircuitPlanComponents = `GET-INVENTORY-CIRCUIT-PLAN-COMPONENTS-${actionTypeIdentifier}`;
export const getInventoryCircuitGlCodeList = `GET-INVENTORY-CIRCUIT-GL-CODE-LIST-${actionTypeIdentifier}`;
export const getInventoryCircuitCostCenterList = `GET-INVENTORY-CIRCUIT-COST-CENTER-LIST-${actionTypeIdentifier}`;
export const GetlinkCircuitsByBillingAccountIdAndCircuitTypeId = `GET-LINKCIRCUITS-BY-BILLINGACCOUNTID-AND-CIRCUITTYPEID${actionTypeIdentifier}`;

export const circuitDetailsModel = {
    circuitCodeConfirmation: false,
    primarySecondaryConfirmation: false,
    circuitID: 0,
    circuitCode: "",
    statusID: 0,
    circuitTypeID: 0,
    subCircuitTypeID: 0,
    monthlyRateCharge: "0.00",
    primarySecondary: "",
    linkedCircuitID: "",
    billingAccountID: 0,
    financeAccountTypeName: "",
    clientName: "",
    vendor: "",
    endUserID: "",
    userName: "",
    emailAddress: "",
    lineManager: "",
    installDate: "",
    disconnectDate: "",
    suspensionFromDate: "",
    suspensionToDate: "",
    contractEndDate: ""
};

export const locationModel = {
    locationID: "",
    address1: "",
    address2: "",
    locationType: "",
    locationCity: "",
    locationState: "",
    locationCountry: "",
    locationZip: "",
    demarcLocation: ""
};